import { Container } from '@mui/material'
import { ReactNode } from 'react'

const ZBottomContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '0.625rem',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flex: 1,
        width: '100%',
        paddingBottom: '2rem',
      }}
    >
      {children}
    </Container>
  )
}

export default ZBottomContainer
